import { DialogTitle, IconButton, Tooltip } from '@mui/material'
import { Close as IconClose } from '@mui/icons-material'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/system'

const useStyles = makeStyles((theme) => ({
  dialogTitleCloseBox: {
    marginLeft: 'auto',
    alignSelf: 'flex-start',
  },
  dialogTitleCloseButton: {
    '&[disabled]': {
      color: theme.palette.grey[400],
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
}))

const DialogTitleClose = (props) => {
  const { children, onClose, isDisabled = false, ...other } = props
  const { dialogTitleCloseBox, dialogTitleCloseButton } = useStyles()
  return (
    <DialogTitle {...other}>
      {children}
      <Tooltip title="Venster sluiten">
        <Box className={dialogTitleCloseBox}>
          <IconButton
            type="button"
            aria-label="close"
            className={dialogTitleCloseButton}
            onClick={onClose}
            disabled={isDisabled}
          >
            <IconClose />
          </IconButton>
        </Box>
      </Tooltip>
    </DialogTitle>
  )
}

DialogTitleClose.propTypes = {
  onClose: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
}

export default DialogTitleClose
